import keycloakAxios from '@/services/axios';

export const getPaymentFee = async () => {
  const response = await keycloakAxios.get(`payments/payment-fee`);

  if (response.status >= 300) {
    throw new Error(
      `Error checking payment fee: Invalid status code: ${response.status}`
    );
  }

  return {...response.data, fixedFee: response.data.fixedFee / 100};
};
